<template>
  <div class="cmp-settings-invoice-project-details-hints-label">
    <img
      class="arrow"
      width="30"
      height="30"
      src="static/icons/question.svg"
      alt
    />
  </div>
</template>
<script>
// import { defaultTextFieldConfig } from "../../../../plugins/text-field";
// import { createCountriesTV } from "../../../../models/country.model";
// import { createCurrencyTV } from "../../../../models/currency.model";
// import { createPaymentMethodTV } from "../../../../models/payment-method.model";
// import { createMoneyAccountTV } from "../../../../models/money-account.model";
// import { tv, createTV } from "../../../../models/text-value.model";
// import InfoCard from "../../../../dt-plugins/info-card/info-card.vue";
// import DTCheckbox from "../../../../plugins/checkbox/checkbox";

export default {
  components: {},
  data() {
    return {
      // textFieldConfig: defaultTextFieldConfig(),
    };
  },
  props: {
    // invoiceProjectDetails: {
    //   required: true,
    // },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.cmp-settings-invoice-project-details-hints-label {
}
</style>